import React, { useContext } from 'react'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import './TrustStrip.scss'

/**
 * The six commitments the site already makes, in one row. Only facts the
 * company stands behind (see docs/client-acquisition.md) — nothing here is
 * a number we would have to defend.
 */
const TrustStrip = ({ className = '' }) => {
  const { translations: t } = useContext(LanguageContext)
  const items = [t.trustReply, t.homeUsp1, t.homeUsp2, t.trustProto, t.homeUsp3, t.trustGdpr].filter(Boolean)

  return (
    <ul className={`trust-strip ${className}`}>
      {items.map((item) => (
        <li key={item}>
          <span className='trust-strip-dot' aria-hidden='true' />
          {item}
        </li>
      ))}
    </ul>
  )
}

export default TrustStrip
